module.exports = __webpack_public_path__ + "img/aeroland-payment-box-icon-04.969db5f5.png";